import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-generic-three-line-message-modal',
  templateUrl: './generic-three-line-message-modal.component.html',
  styleUrls: ['./generic-three-line-message-modal.component.css']
})
export class GenericThreeLineMessageModalComponent implements OnInit {

  constructor(
    private router: Router,
    private dialogRef: MatDialogRef<GenericThreeLineMessageModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit(): void {
  }

}
